var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"defaultcontent-grid",attrs:{"id":"lander-overview"}},[_c('ExhibitionCurrent',{attrs:{"exhibitions":_vm.exhibitions}}),_c('ActivitiesList',{attrs:{"adult_activities":_vm.adult_acts,"child_activities":_vm.child_acts}}),_c('PostsList',{attrs:{"posts":_vm.posts}}),_c('BaseInfoBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }